import { shop } from '@/config/api'
import ApiService from '@/services/api.service'

const state = () => ({
    shopList: [],
    topics: [],
    dates: [],
    specialtiesList: [],
    shopTotal: 0,
    content: null,
    filesTotal: 0,
    userFilesTotal: 0,
    shopLimitOnPage: 10,
    filesLimitOnPage: 10,
    files: [],
    userFiles: [],
    errors: []

})

const getters = {
    getShopsList: state => state.shopList,
    getShop: state => state.content,
    getFiles: state => state.files,
    getDates: state => state.dates,
    getUserFiles: state => state.userFiles,
    getShopsTotal: state => state.shopTotal,
    getFilesTotal: state => state.filesTotal,
    getUserFilesTotal: state => state.userFilesTotal,
    getShopsLimitOnPage: state => state.shopLimitOnPage,
    getFilesLimitOnPage: state => state.filesLimitOnPage,
    getErrors: state => state.errors
}

const actions = {

    async fetchShopsList ({ commit, getters }, params) {
        const formattedParams = {
            ...params,
            limit: params.limit || getters.getShopsLimitOnPage,
            offset: (getters.getShopsLimitOnPage * (parseInt(params.page) || 1)) - getters.getShopsLimitOnPage
        }
        try {
            // commit('START_LOAD_DNT_LIST')
            const response = await ApiService.get(shop.list, {
                params: {
                    ...formattedParams
                }
            })

            commit('SET_SHOP_LIST', {
                payload: response.data.data,
                headers: response.headers
            })
        } catch (err) {
            commit('SET_SHOP_LIST', {
                payload: [],
                headers: {}
            })
            console.log(err)
            throw err
        }
    },

    async fetchShop ({ commit,  }, alias) {

        try {
            commit('START_LOAD_EXHIBITION')
            const response = await ApiService.get(shop.content(alias), {

            })

            commit('SET_EXHIBITION_CONTENT', {
                payload: response.data.data
            })
        } catch (err) {
            commit('SET_EXHIBITION_CONTENT', {
                payload: []
            })
            console.log(err)
            throw err
        }
    },

    async fetchFiles ({ commit, getters }, params) {
        const formattedParams = {
            ...params,
            limit: params.limit || getters.getFilesLimitOnPage,
            offset: (getters.getFilesLimitOnPage * (parseInt(params.page) || 1)) - getters.getFilesLimitOnPage
        }
        try {

            const response = await ApiService.get(shop.files(params.orderId), {
                params: {
                    language: 'en',
                    ...formattedParams
                },
                useCache: true
            })

            commit('SET_TASKS_LIST', {
                payload: response.data.data,
                headers: response.headers
            })
        } catch (err) {
            commit('SET_TASKS_LIST', {
                payload: [],
                headers: {}
            })
            console.log(err)
            throw err
        }
    },

    async fetchDates ({ commit, getters }, params) {
        const limit = params.limit || 50
        const offset = isNaN(params.offset) ? (limit * (parseInt(params.page) || 1)) - limit  : params.offset
        const formattedParams = {
            ...params,
            limit: limit,
            offset: offset
        }
        try {
            //commit('START_LOAD_CHALLENGE_LIST')
            const response = await ApiService.get(shop.dates(params.orderId), {
                params: {
                    dev: true,
                    language: 'en',
                    ...formattedParams
                },
                useCache: true
            })


            commit('SET_EXHIBITION_DATES', {
                payload: response.data.data
            })
        } catch (err) {
            console.log(err)
            throw err
        }
    },

    async fetchUserFiles ({ commit, getters }, params) {
        const formattedParams = {
            ...params,
            limit: params.limit || getters.getFilesLimitOnPage,
            offset: (getters.getFilesLimitOnPage * (parseInt(params.page) || 1)) - getters.getFilesLimitOnPage
        }
        try {
            // commit('START_LOAD_DNT_LIST')
            const response = await ApiService.get(shop.files(0), {
                params: {
                    accepted: true,
                    language: 'en',
                    ...formattedParams
                },
                useCache: true
            })

            commit('SET_USER_TASKS_LIST', {
                payload: response.data.data,
                headers: response.headers
            })
        } catch (err) {
            commit('SET_USER_TASKS_LIST', {
                payload: [],
                headers: {}
            })
            console.log(err)
            throw err
        }
    },


    async saveShop ({commit}, data) {
        try {
            const response = await ApiService.post(shop.save, data)
            if (typeof response.data.error != 'undefined') {
                commit('ADD_ERROR', response.data.error)
                return false
            } else {
                return response
            }
        } catch (err) {
            console.log('err', err)
            throw err
        }
    },

    async deleteShop ({commit}, orderId) {
        try {
            const response = await ApiService.post(shop.delete, {order_id: orderId})
            if (typeof response.data.error != 'undefined') {
                commit('ADD_ERROR', response.data.error)
                return false
            } else {
                return response
            }
        } catch (err) {
            console.log('err', err)
            throw err
        }
    },

    async acceptShop ({commit}, data) {
        try {
            const response = await ApiService.post(shop.accept, data)
            if (typeof response.data.error != 'undefined') {
                commit('ADD_ERROR', response.data.error)
                return false
            } else {
                return response
            }
        } catch (err) {
            console.log('err', err)
            throw err
        }
    },

    async doFile ({commit}, data) {
        try {
            const response = await ApiService.post(shop.doFile, data)
            if (typeof response.data.error != 'undefined') {
                commit('ADD_ERROR', response.data.error)
                return false
            } else {
                return response
            }
        } catch (err) {
            console.log('err', err)
            throw err
        }
    },

    async nextDay ({commit}, data) {
        try {
            const response = await ApiService.post(shop.nextDay, data)
            if (typeof response.data.error != 'undefined') {
                commit('ADD_ERROR', response.data.error)
                return false
            } else {
                return response
            }
        } catch (err) {
            console.log('err', err)
            throw err
        }
    },

    async closeShop ({commit}, data) {
        try {
            const response = await ApiService.post(shop.close, data)
            if (typeof response.data.error != 'undefined') {
                commit('ADD_ERROR', response.data.error)
                return false
            } else {
                return response
            }
        } catch (err) {
            console.log('err', err)
            throw err
        }
    },

    async clearErrors ({commit}) {
        commit('CLEAR_ERRORS')
    }
}

const mutations = {
    CLEAR_ERRORS (state) {
        state.errors = []
    },

    ADD_ERROR (state, payload) {
        state.errors.push(payload)
    },

    START_LOAD_EXHIBITION(state) {
        state.content = null
    },

    SET_SHOP_LIST (state, { payload, headers }) {
        state.shopList = payload
        state.shopTotal = parseInt(headers['x-items-total'])
    },

    SET_TASKS_LIST (state, { payload, headers }) {
        state.files = payload
        state.filesTotal = parseInt(headers['x-items-total'])
    },

    SET_EXHIBITION_CONTENT (state, { payload }) {
        state.content = payload
    },

    SET_EXHIBITION_DATES (state, { payload }) {
        state.dates = payload
    },

    SET_USER_TASKS_LIST (state, { payload, headers }) {
        state.userFiles = payload
        state.userFilesTotal = parseInt(headers['x-items-total'])
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
